import { rest } from 'msw';

import { API_URLS } from '~/configs/api/urls';
import { SecTrackingIdResponse } from '~/utils/tiara';

export const 티아라_TRACKING_ID_정상응답: SecTrackingIdResponse = {
  trackingId: 'd001f8dd2879446e06b6453',
};

export const 티아라_TRACKING_ID_응답_빈값: SecTrackingIdResponse = {
  trackingId: '',
};

const 티아라_TRACKING_ID_조회 = rest.get(
  API_URLS.ANALYSIS.TRACKING_ID,
  (_, res, ctx) => res(ctx.json(티아라_TRACKING_ID_정상응답))
);

export default 티아라_TRACKING_ID_조회;
